import Card from "components/card/Card";
import SelectNew from "components/select/SelectNew";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { GetCustomerType } from "api/rpc/2024-04/facilityAdmin/customer/type";
import { TCustomerType } from "redux/reducers/models/facility";

interface IDiscountCustomerTypeProps {
  stateCallback: (id: string, products: TCustomerType[]) => void;
  discountCustomerType: TCustomerType[];
}
export default function DiscountCustomerTypeSelect(props: IDiscountCustomerTypeProps) {
  const { stateCallback, discountCustomerType } = props;
  const { t } = useTranslation();

  const [customerTypes, setCustomerTypes] = useState<TCustomerType[]>([]);

  useEffect(() => {
    void loadCustomerTypes();
  }, []);
  async function loadCustomerTypes() {
    const customerTypes = await GetCustomerType(null, true);

    setCustomerTypes(customerTypes.data);
  }

  function handleSelectTypes(selectedType: TCustomerType) {
    let updated;

    if (discountCustomerType?.some(type => type.id === selectedType.id)) {
      updated = discountCustomerType?.filter(type => type.id !== selectedType.id);
    } else {
      updated = [...discountCustomerType, selectedType];
    }

    stateCallback("discounted_customer_types", updated);
  }
  function handleCustomerTypeMultiValue() {
    const ids = [];
    for (let i = 0; i < discountCustomerType?.length; i++) {
      ids.push(customerTypes.find(type => type.id === discountCustomerType[i].id)?.id);
    }

    return ids;
  }

  function getCustomerTypePlaceholder() {
    const customerTypeTitles = [];
    for (let i = 0; i < discountCustomerType.length; i++) {
      customerTypeTitles.push(customerTypes.find(type => type.id === discountCustomerType[i].id)?.title ?? "");
    }
    return customerTypeTitles.join(", ");
  }

  return (
    <Card>
      <Card.Section>
        <SelectNew
          label={t("Customer Types")}
          id="customer_type"
          options={
            customerTypes?.map(type => ({
              id: type.id,
              label: `${type.full_title}`,
              extraValue: type,
            })) ?? []
          }
          multiValue={handleCustomerTypeMultiValue()}
          onChange={(_, extraValue) => handleSelectTypes(extraValue)}
          placeholder={
            discountCustomerType?.length > 0 ? getCustomerTypePlaceholder() : t("No Customer Types Selected")
          }
        />
      </Card.Section>
    </Card>
  );
}
